import axios from "axios";
import { CustomerDetailsResponse } from "redmond";

import { customerDetailsApiPath } from "../paths";
import { config } from "../../config";

export const fetchCustomerDetails = async (): Promise<CustomerDetailsResponse> => {
  const res = await axios.get(customerDetailsApiPath, {
    baseURL: config.baseURL,
  });

  return res.data;
};
